import { useSelector } from 'react-redux';
import i18n from './i18n';
import Cookies from 'js-cookie';

import { useEffect } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

import { SnackbarProvider } from 'notistack';

// routing
import PublicRoutes from 'routes/PublicRoutes';
import PrivateRoutes from 'routes/PrivateRoutes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import ResponsiveDialog from 'ui-component/extended/ResponsiveDialog';

// ==============================|| APP ||============================== //

const App = () => {
    const locale = useSelector((state) => state.app.locale);
    const customization = useSelector((state) => state.customization);

    const selectedLocale = locale || Cookies.get('locale') || 'id';
    console.log('selected locale: ', selectedLocale);
    i18n.locale = selectedLocale;

    // Please wait until storage is loaded then render
    // the routes
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <SnackbarProvider maxSnack={3}>
                    <CssBaseline />
                    <NavigationScroll>
                        <PublicRoutes />
                        <PrivateRoutes />
                        <ResponsiveDialog />
                    </NavigationScroll>
                </SnackbarProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
